const ESTIMATE_SELECTIONS_KEY = 'ubuntu-estimate-selections-v1';

const defaultSelections = {
  soundHirePackageId: 'none',
  soundAddOnIds: [],
  smokeMachinePackageId: 'none',
  venueSupportPackageId: 'none',
  estimateEventContext: {
    name: '',
    eventDate: '',
    guests: '',
    location: '',
  },
  estimatedTotal: 0,
};

const safeParseJson = (value) => {
  try {
    return JSON.parse(value);
  } catch (err) {
    return null;
  }
};

export const loadEstimateSelections = () => {
  if (typeof window === 'undefined') return { ...defaultSelections };

  try {
    const raw = localStorage.getItem(ESTIMATE_SELECTIONS_KEY);
    const parsed = safeParseJson(raw);
    if (!parsed) return { ...defaultSelections };

    return {
      ...defaultSelections,
      ...parsed,
      soundAddOnIds: Array.isArray(parsed.soundAddOnIds)
        ? parsed.soundAddOnIds
        : [],
      estimateEventContext: {
        ...defaultSelections.estimateEventContext,
        ...(parsed.estimateEventContext || {}),
      },
    };
  } catch {
    return { ...defaultSelections };
  }
};

export const saveEstimateSelections = (selections) => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(
      ESTIMATE_SELECTIONS_KEY,
      JSON.stringify(selections)
    );
  } catch {
    // Ignore storage failures (private mode, blocked storage, etc.)
  }
};

export const patchEstimateSelections = (patch) => {
  const prev = loadEstimateSelections();

  const next = {
    ...prev,
    ...patch,
  };

  // Keep array semantics stable
  if (patch.soundAddOnIds !== undefined) {
    next.soundAddOnIds = Array.isArray(patch.soundAddOnIds)
      ? patch.soundAddOnIds
      : [];
  } else {
    next.soundAddOnIds = prev.soundAddOnIds;
  }

  saveEstimateSelections(next);
  return next;
};

export const setSoundHirePackage = (packageId) => {
  return patchEstimateSelections({
    soundHirePackageId: packageId || 'none',
  });
};

export const setSmokeMachinePackage = (packageId) => {
  return patchEstimateSelections({
    smokeMachinePackageId: packageId || 'none',
  });
};

export const setVenueSupportPackage = (packageId) => {
  return patchEstimateSelections({
    venueSupportPackageId: packageId || 'none',
  });
};

export const setEstimateEventContext = (context = {}) => {
  return patchEstimateSelections({
    estimateEventContext: {
      ...defaultSelections.estimateEventContext,
      ...context,
    },
  });
};

export const toggleSoundAddOn = (addOnId) => {
  const prev = loadEstimateSelections();
  const has = prev.soundAddOnIds.includes(addOnId);
  const nextIds = has
    ? prev.soundAddOnIds.filter((id) => id !== addOnId)
    : [...prev.soundAddOnIds, addOnId];

  return patchEstimateSelections({ soundAddOnIds: nextIds });
};

